import { useState } from 'react'
import { useAuth } from '../../../__legacy__/hooks/useAuth'
import useFavorite from '../../../__legacy__/hooks/useFavorite'
import { useMedia } from './useMedia'

export const useFavoriteButton = () => {
  const { favoriteCount, id, type } = useMedia()
  const { toggleFavorite, isFavorited } = useFavorite(id, type)
  const [increment, setIncrement] = useState(0)
  const { user } = useAuth()
  const handleClick = (evt) => {
    if (!user) return
    evt.stopPropagation()
    setIncrement(isFavorited ? -1 : 1)
    toggleFavorite()
  }
  return { isFavorited, favoriteCount: favoriteCount || 0 + increment, handleClick }
}
